export enum ElementTypes {
    BarrierBlock = "BarrierBlock",
    BasicBlock = "BasicBlock",
    BounceBlock = "BounceBlock",
    FloorBlock = "FloorBlock",
    Group = "Group",
    Joint = "Joint",
    Unknown = "Unknown",
}